import i18n from '../../../i18n';

export const _contactDetails = (_mappedMetadata: any) => {

  return [
    // {
    //   name: 'Ιδιοκτήτης Τοποθεσίας',
    //   value: '',
    //   refValue: 'locationOwners',
    // },
    ...(_mappedMetadata?.locationAvailablePeople !== ' -'
      ? [{
        name: 'Υπεύθυνος Επικοινωνίας',
        value: '',
        refValue: 'locationAvailablePeople',
      }] :
      []),
    ...(_mappedMetadata?.locationPhone !== '-'
      ? [{
        name: 'Τηλέφωνο',
        value: '',
        refValue: 'locationPhone',
      }] :
      []),
    ...(_mappedMetadata?.locationEmail !== '-'
      ? [{
        name: 'Email',
        value: '',
        refValue: 'locationEmail',
      }] :
      []),
    ...(_mappedMetadata?.locationWebsite !== '-'
      ? [{
        name: 'Website',
        value: '',
        refValue: 'locationWebsite',
      }] :
      []),
  ];
};

export const _usefulInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.locationCategoriesL1 !== '-'
      ? [{
        name: 'Θεματική Ενότητα',
        value: '',
        refValue: 'locationCategoriesL1',
      }] :
      []),
    ...(_mappedMetadata?.locationCategories !== '-'
      ? [{
        name: 'Κατηγορία',
        value: '',
        refValue: 'locationCategories',
      }] :
      []),
    ...(_mappedMetadata?.locationScope !== '-'
      ? [{
        name: 'Δημόσιος/Ιδιωτικός Χώρος',
        value: '',
        refValue: 'locationScope',
      }] :
      []),
    ...(_mappedMetadata?.licenseInformation !== '-' && i18n.language !== 'en'
      ? [{
        name: 'Πληροφορίες Αδειοδότησης',
        value: '',
        refValue: 'licenseInformation',
      }] :
      []),
    ...(_mappedMetadata?.licenseInformation_en !== '-' && i18n.language !== 'el'
      ? [{
        name: 'Πληροφορίες Αδειοδότησης',
        value: '',
        refValue: 'licenseInformation_en',
      }] :
      []),
    ...(_mappedMetadata?.locationFilmOffice !== '-'
      ? [{
        name: 'Film Office που ανήκει Διοικητικά',
        value: '',
        refValue: 'locationFilmOffice',
      }] :
      []),
    ...(_mappedMetadata?.locationAccessSpecialNeeds !== '-'
      ? [{
        name: 'Πρόσβαση σε άτομα με ειδικές ανάγκες',
        value: '',
        refValue: 'locationAccessSpecialNeeds',
      }] :
      []),
    ...(_mappedMetadata?.locationAccessToHeavyVehicles !== '-'
      ? [{
        name: 'Πρόσβαση σε βαρέα οχήματα',
        value: '',
        refValue: 'locationAccessToHeavyVehicles',
      }] :
      []),
    ...(_mappedMetadata?.locationPlaceRestrictions !== '-' && i18n.language !== 'en'
      ? [{
        name: 'Περιορισμοί',
        value: '',
        refValue: 'locationPlaceRestrictions',
      }] :
      []),
    ...(_mappedMetadata?.restrictions_en !== '-' && i18n.language !== 'el'
      ? [{
        name: 'Περιορισμοί',
        value: '',
        refValue: 'restrictions_en',
      }] :
      []),
  ];
};

export const _locationInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.address !== '-'
      ? [{
        name: 'Διεύθυνση',
        value: '',
        refValue: 'address',
      }] :
      []),
    ...(_mappedMetadata?.postal_code !== '-'
      ? [{
        name: 'Ταχυδρομικός Κώδικας',
        value: '',
        refValue: 'postal_code',
      }] :
      []),
    ...(_mappedMetadata?.region !== '-'
      ? [{
        name: 'Περιφέρεια',
        value: '',
        refValue: 'region',
      }] :
      []),
  ];
};
